/**
 * Dr. Salus — Safety Monitor Service
 * API calls para a base curada de regras de segurança médica e para as
 * ocorrências catalogadas pelo validador (gpt-5.4-mini).
 */
import api from '../global/api';

class SafetyService {
  // ============================================
  // RULES (base curada)
  // ============================================

  async listRules() {
    const response = await api.get('/api/dr-salus/safety/rules');
    return response.data;
  }

  async createRule({ title, rule, category, severity, triggers, source }) {
    const response = await api.post('/api/dr-salus/safety/rules', {
      title, rule, category, severity, triggers, source,
    });
    return response.data;
  }

  async updateRule(ruleId, updates) {
    const response = await api.put(`/api/dr-salus/safety/rules/${ruleId}`, updates);
    return response.data;
  }

  async deactivateRule(ruleId) {
    const response = await api.delete(`/api/dr-salus/safety/rules/${ruleId}`);
    return response.data;
  }

  // ============================================
  // EVENTS (ocorrências catalogadas)
  // ============================================

  async listEvents({ flagged, category, status, phone, limit } = {}) {
    const params = {};
    if (flagged !== undefined && flagged !== null) params.flagged = flagged;
    if (category) params.category = category;
    if (status) params.status = status;
    if (phone) params.phone = phone;
    if (limit) params.limit = limit;
    const response = await api.get('/api/dr-salus/safety/events', { params });
    return response.data;
  }

  async updateEvent(eventId, { status, review_note }) {
    const response = await api.put(`/api/dr-salus/safety/events/${eventId}`, {
      status, review_note,
    });
    return response.data;
  }

  async getStats() {
    const response = await api.get('/api/dr-salus/safety/stats');
    return response.data;
  }
}

const safetyService = new SafetyService();
export default safetyService;
